// extracted by mini-css-extract-plugin
module.exports = {"label":"rectangleAd_label__1KLxh","content":"rectangleAd_content__ahXqo","desc":"rectangleAd_desc__R5bh5","link":"rectangleAd_link__yKWVM"};